import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const ADSPageLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default ADSPageLayout;